define('views/modals/select-deal/content',[
    'jquery',
    'underscore',
    'mediator',

    'views/base/view',
    'lib/utils',

    'text!templates/modals/select-deal/content-loading.ejs',

    'views/modals/select-deal/goods-collection'

], function(
    $, _, mediator,
    View, utils,
    templateLoading,

    SelectDealGoodsCollectionView
) {
    'use strict';

    var ContentLoadingView = View.extend({
        autoRender: true,
        className: 'loading',
        template: templateLoading
    });

    var SelectDealModalContentView = View.extend({
        autoRender: true,
        className: 'select-deal-modal-content',
        region: 'modal-content',
        listen: {
            'afterLoad model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            if (this.model.get('loaded')) {
                this.subview('content', new SelectDealGoodsCollectionView({ model: this.model, collection: this.model.items, container: this.el }));
            } else {
                this.subview('content', new ContentLoadingView({ model: this.model, container: this.el }));
            }

        },
        afterLoad: function() {
            this.render();
        }
    });

    return SelectDealModalContentView;
});

